export default "__VITE_ASSET__jAmt9C$l__"